import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import { useNotifications } from '@/stores/notifications'
import { useTransactions } from '@/stores/transactions'
import { useRoute } from 'vue-router'
import { useConfirm } from '@/composables/useConfirm'
import useGlobal from '@/composables/useGlobal'
import {
  NOTIFICATIONS_PAGE_NAME
} from '@/components/pages/cabinet/routes'
import { isLp, isAdmin } from '@access/permissions'

import {
  notificationsListResource,
  notificationChangeFlagResource,
  notificationClearResource
} from '@/services/notifications.service'

const NOTIFICATIONS_LIMIT = 10

export default /*#__PURE__*/_defineComponent({
  __name: 'NotifyBar',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute()
const store = useNotifications()
const attentionsStore = useTransactions()
const unreadCounter = computed(() => store.getUnread)
const unreadCount = computed(() => store.unreadCount)
const attentionsCounter = computed(() => attentionsStore.getAttentionsCount)
const attentionsCount = computed(() => attentionsStore.attentionsCount)
const load = ref(false)
const { $t } = useGlobal()
const notificationsList = ref([])

async function getMessagesList(toggler) {
  const transformedData = {
    header: true,
    limit: NOTIFICATIONS_LIMIT,
  }
  load.value = true
  try {
    if(toggler) await toggler()
    const { items, pagination } = (await notificationsListResource.execute({...transformedData}))
    notificationsList.value = items
    load.value = false
  } catch (e) {
    return Promise.reject(e)
  }
}

async function readMessages(id) {
  const question = $t('Сonfirm action')
  const preparedData = {
    add: [73236],
    remove: [73232]
  }
  try {
    if(id =='all') await useConfirm(question)
    const data = await notificationChangeFlagResource.execute(id =='all' ? {} : {ids: [id] }, { ...preparedData })
    await unreadCounter.value()
    getMessagesList()
  } catch (e) {
    return Promise.reject(e)
  }
}

// const intervalCounter = setInterval(unreadCounter.value, 60000)

watch(() => route, () => {
    unreadCounter.value()
    if(isAdmin) attentionsCounter.value()
  }, {immediate: true, deep: true })


const __returned__ = { NOTIFICATIONS_LIMIT, route, store, attentionsStore, unreadCounter, unreadCount, attentionsCounter, attentionsCount, load, $t, notificationsList, getMessagesList, readMessages, ref, computed, watch, get useNotifications() { return useNotifications }, get useTransactions() { return useTransactions }, get useRoute() { return useRoute }, get useConfirm() { return useConfirm }, get useGlobal() { return useGlobal }, get NOTIFICATIONS_PAGE_NAME() { return NOTIFICATIONS_PAGE_NAME }, get isLp() { return isLp }, get isAdmin() { return isAdmin }, get notificationsListResource() { return notificationsListResource }, get notificationChangeFlagResource() { return notificationChangeFlagResource }, get notificationClearResource() { return notificationClearResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})